import { debounce as _debounce, throttle as _throttle } from 'throttle-debounce';

/** 什么都不做的空函数 */
export function noop(): void {
  // empty function
}

/**
 * 节流执行函数。对于限制诸如大小调整和滚动之类的事件对处理程序的执行的速率限制特别有用。
 * @param delay
 * 大于0的延迟（单位为毫秒）。大约100毫秒或250毫秒（甚至更高）的值最有用。
 * @param noTrailing
 * 如果`noTrailing`为`true`，则在调用节流函数时，回调将仅在每`delay`毫秒执行一次。
 * 如果`noTrailing`为`false`或未指定，则将在节流函数的最后一次调用之后执行回调。
 * （当节流函数超过`delay`毫秒 未被执行，内部计数器将重置 ）
 * @param callback
 * 每`delay`毫秒会被执行一次的函数。执行时，此回调函数的上下文和所有参数将按原样传递。
 * @param debounceMode
 * 如果`debounceMode`为`true`（在开始时），则调度回调在`delay`毫秒之后执行。 如果`debounceMode`为`false`（最后），则安排回调在`delay`毫秒之后执行。
 * @returns 一个新的被节流的函数。
 * @description 此函数来自第三方库 [throttle-debounce](https://github.com/niksy/throttle-debounce) ([source](https://github.com/niksy/throttle-debounce/blob/master/throttle.js))
 * @example
 * ```js
 * throttle(200, function);
 * ```
 * 可通过调用`cancel`来取消
 * ```js
 * const throttled = throttle(200, () => {
 * // Throttled function
 * });
 * throttled.cancel();
 * ```
 */
export const throttle = _throttle;

/**
 * 防抖执行函数。与节流不同，防抖保证函数只能在一系列调用的开始或结束时执行一次。
 * @param delay
 * 大于0的延迟（单位为毫秒）。大约100毫秒或250毫秒（甚至更高）的值最有用。
 * @param atBegin
 * 如果`atBegin`为`false`或未指定，则回调将仅在上次防抖函数调用后`delay`毫秒执行。 如果`atBegin`为`true`，则仅在第一个防抖函数调用时执行回调。 （在延迟毫秒内未调用节流功能后，将重置内部计数器）。
 * @param callback
 * 每`delay`毫秒会被执行一次的函数。执行时，此回调函数的上下文和所有参数将按原样传递。
 * @returns 一个新的去抖动的函数。
 * @description 此函数来自第三方库 [throttle-debounce](https://github.com/niksy/throttle-debounce) ([source](https://github.com/niksy/throttle-debounce/blob/master/debounce.js))
 * @example
 * ```js
 * debounce(200, function);
 * ```
 * 可通过调用`cancel`来取消
 * ```js
 * const debounced = debounce(200, () => {
 * // Throttled function
 * });
 * debounced.cancel();
 * ```
 */
export const debounce = _debounce;
